import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';
import { withLoading } from '@ps/core-loading';
import { ComputeFeasibilityParams } from '@ps/survey-utils';

import { PurePriceCpiResponseDto } from './dtos/pure-price-cpi.dto';
import { PurePriceCpiPayloadMapper } from './mappers/pure-price-cpi.payload.mapper';

@Injectable({ providedIn: 'root' })
export class PurePriceCpiApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);

  private readonly _baseUrl = this._env.pureSpectrum.url;

  private readonly _mapper = new PurePriceCpiPayloadMapper();

  public compute(
    surveyId: number,
    params: ComputeFeasibilityParams,
  ): Observable<number> {
    return this._http
      .post<PurePriceCpiResponseDto>(
        `${this._baseUrl}/buyers/v2/surveys/${surveyId}/pure-price-cpi`,
        this._mapper.toPayload(params),
        { context: withLoading('content') },
      )
      .pipe(map((dto) => dto.CPI));
  }
}
